import * as React from "react";
import {
    AppState,
    clientForm,
    clientFormBindings,
    saveClientAction,
    changeStatusCreateClientModalAction,
    uploadMappingsForCreateClient,
    IndustryMapping,
    CategoryMapping,
    Country
} from "@store";
import { Dispatch, connect } from "react-redux";
import "./CreateClientComponent.css";
import { FetchingState } from "rd-redux-http";
import { Fieldset } from "./Fieldset";
import { Triangle } from "@icons";

export interface CreateClientComponentProps {
    clientFormData: typeof clientForm.types.selectorResult;
    clientFormEvents: typeof clientForm.types.eventBindings;
    industriesMapping: IndustryMapping[];
    categoriesMapping: CategoryMapping[];
    countryList: Country[];
    onChangeStatusCreateClientModal: (isOpen: boolean) => void;
    onUploadDropdowns: () => void;
    onSaveClient: () => void;
}

export interface CreateClientComponentState {}

class CreateClientComponent extends React.Component<CreateClientComponentProps, CreateClientComponentState> {
    componentDidMount() {
        this.props.onUploadDropdowns();
        this.props.clientFormEvents.fields.invoice.onChange("false");
    }

    render() {
        const {
            clientFormData: form,
            clientFormEvents: events,
            onChangeStatusCreateClientModal,
            industriesMapping,
            categoriesMapping,
            countryList,
            onSaveClient
        } = this.props;
        return (
            <div className="createClient">
                <h3 className="createClient-title">Client Details</h3>
                <div className="createClient-cols-wrapper">
                    <div className="createClient-col">
                        <Fieldset
                            className="custom-createClient-fieldset createClient-col-item"
                            label="Account Name"
                            errorMessage={form.fields.accountName}
                            isMandatory={true}
                        >
                            <input
                                type="text"
                                name=""
                                id=""
                                value={form.fields.accountName.value || ""}
                                {...events.fields.accountName}
                                maxLength={160}
                            />
                        </Fieldset>
                        <Fieldset
                            className="custom-createClient-fieldset createClient-col-item"
                            label="Email"
                            errorMessage={form.fields.email}
                            isMandatory={true}
                        >
                            <input
                                type="text"
                                name=""
                                id=""
                                value={form.fields.email.value || ""}
                                {...events.fields.email}
                                maxLength={100}
                            />
                        </Fieldset>
                        <Fieldset className="createClient-col-item" label="Phone" errorMessage={form.fields.phone}>
                            <input
                                type="text"
                                name=""
                                id=""
                                value={form.fields.phone.value || ""}
                                {...events.fields.phone}
                                maxLength={50}
                            />
                        </Fieldset>
                        <Fieldset
                            className="createClient-col-item"
                            label="Category"
                            errorMessage={form.fields.category}
                            isMandatory={true}
                            icon={Triangle}
                            svgClassName="svg-triangle"
                        >
                            <select
                                className="common-select custom-createClient-select"
                                name="country"
                                id=""
                                value={form.fields.category.value || ""}
                                {...events.fields.category}
                            >
                                <option value="">Select category</option>
                                {categoriesMapping.length > 0 &&
                                    categoriesMapping.map((category, index) => (
                                        <option key={index} value={category.type}>
                                            {category.type}
                                        </option>
                                    ))}
                            </select>
                        </Fieldset>
                        <Fieldset
                            className="createClient-col-item"
                            label="Industry"
                            errorMessage={form.fields.industry}
                            isMandatory={true}
                            icon={Triangle}
                            svgClassName="svg-triangle"
                        >
                            <select
                                className="common-select custom-createClient-select"
                                name="country"
                                id=""
                                value={form.fields.industry.value || ""}
                                {...events.fields.industry}
                            >
                                <option value="">Select industry</option>
                                {industriesMapping.length > 0 &&
                                    industriesMapping.map((industry, index) => (
                                        <option key={index} value={industry.type}>
                                            {industry.type}
                                        </option>
                                    ))}
                            </select>
                        </Fieldset>
                        <div className="createClient-col-item createClient-checkbox">
                            <label className="common-radio custom-create-client-radio important">
                                <input
                                    type="radio"
                                    name="invoice"
                                    value={form.fields.invoice.value}
                                    id=""
                                    checked={form.fields.invoice.value === "true" ? true : false}
                                    onChange={() => ""} // fix warning
                                    onClick={() =>
                                        events.fields.invoice.onChange(
                                            form.fields.invoice.value === "false" ? "true" : "false"
                                        )
                                    }
                                />
                                <span className="checkmark" />
                                <span className="create-client-title">Generate separate invoice</span>
                            </label>
                        </div>
                    </div>
                    <div className="createClient-col">
                        <Fieldset
                            className="custom-createClient-fieldset createClient-col-item"
                            label="Address Line 1"
                            errorMessage={form.fields.addressLine1}
                            isMandatory={true}
                        >
                            <input
                                type="text"
                                name=""
                                id=""
                                value={form.fields.addressLine1.value || ""}
                                {...events.fields.addressLine1}
                                maxLength={250}
                            />
                        </Fieldset>
                        <Fieldset
                            className="custom-createClient-fieldset createClient-col-item"
                            label="Address Line 2"
                            errorMessage={form.fields.addressLine2}
                        >
                            <input
                                type="text"
                                name=""
                                id=""
                                value={form.fields.addressLine2.value || ""}
                                {...events.fields.addressLine2}
                                maxLength={250}
                            />
                        </Fieldset>
                        <Fieldset
                            className="custom-createClient-fieldset createClient-col-item"
                            label="City"
                            errorMessage={form.fields.city}
                            isMandatory={true}
                        >
                            <input
                                type="text"
                                name=""
                                id=""
                                value={form.fields.city.value || ""}
                                {...events.fields.city}
                                maxLength={80}
                            />
                        </Fieldset>
                        <Fieldset
                            className="custom-createClient-fieldset createClient-col-item"
                            label="State / Province"
                            errorMessage={form.fields.stateOrProvince}
                        >
                            <input
                                type="text"
                                name=""
                                id=""
                                value={form.fields.stateOrProvince.value || ""}
                                {...events.fields.stateOrProvince}
                                maxLength={50}
                            />
                        </Fieldset>
                        <Fieldset
                            className="custom-createClient-fieldset createClient-col-item"
                            label="ZIP Code"
                            errorMessage={form.fields.zipCode}
                            isMandatory={true}
                        >
                            <input
                                type="text"
                                name=""
                                id=""
                                value={form.fields.zipCode.value || ""}
                                {...events.fields.zipCode}
                                maxLength={20}
                            />
                        </Fieldset>
                        <Fieldset
                            className="custom-createClient-fieldset createClient-col-item"
                            label="Select country"
                            errorMessage={form.fields.country}
                            isMandatory={true}
                            icon={Triangle}
                            svgClassName="svg-triangle"
                        >
                            <select
                                className="common-select custom-createClient-select"
                                name="country"
                                id=""
                                value={form.fields.country.value || ""}
                                {...events.fields.country}
                            >
                                <option value="">Select country</option>
                                {countryList.length > 0 &&
                                    countryList.map((country, index) => (
                                        <option key={index} value={country.iso}>
                                            {country.name}
                                        </option>
                                    ))}
                            </select>
                        </Fieldset>
                    </div>
                </div>
                <div className="createClient-controls-wrapper">
                    <button
                        className="common-btn custom-createClient-control-btn"
                        type="button"
                        onClick={() => onSaveClient()}
                    >
                        Save
                    </button>
                    <button
                        className="common-btn custom-createClient-control-btn"
                        type="button"
                        onClick={() => onChangeStatusCreateClientModal(false)}
                    >
                        Cancel
                    </button>
                </div>
            </div>
        );
    }
}

export interface CreateClientProps {}

export const CreateClient = connect(
    (state: AppState, ownProps: CreateClientProps) => {
        const industriesMapping: IndustryMapping[] =
            FetchingState.isSuccess(state.mappings.industries) && state.mappings.industries.data;

        const categoriesMapping: CategoryMapping[] =
            FetchingState.isSuccess(state.mappings.categories) && state.mappings.categories.data;

        return {
            clientFormData: clientForm.selector(state.clientState.clientForm),
            industriesMapping: industriesMapping || [],
            categoriesMapping: categoriesMapping || [],
            countryList:
                (FetchingState.isSuccess(state.clientState.countryList) && state.clientState.countryList.data) || []
        };
    },
    (dispatch: Dispatch, ownProps: CreateClientProps) => ({
        clientFormEvents: clientFormBindings.bind(dispatch, undefined),
        onChangeStatusCreateClientModal: (isOpen: boolean) => {
            dispatch(changeStatusCreateClientModalAction({ isOpen: isOpen }));
        },
        onUploadDropdowns() {
            dispatch(uploadMappingsForCreateClient({}));
        },
        onSaveClient() {
            dispatch(saveClientAction({}));
        }
    })
)(CreateClientComponent);
